module.exports = __webpack_public_path__ + "img/video.8b6e91c3.png";